<template>
  <div class="container">
    <div class="head">
      <span>附件</span>
      <el-dropdown @command="handleCommand" trigger="click">
        <span class="el-dropdown-link icon-plus" v-show="fileList.length < extraConfig.maxLength"></span>
        <el-dropdown-menu slot="dropdown" class="bg-menu">
          <el-dropdown-item v-for="(list, index) in fileTypeList" :key="'bgdrop_' + index" :command="list.type"
            ><img :src="list.src" alt="" />{{ list.label }}</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="content swiper-page">
      <draggable
        element="ul"
        v-model="fileList"
        handle=".mover"
        ghost-class="ghost"
        chosen-class="chosen"
        @start="startDrag"
        @end="endDrag"
      >
        <li class="bg-item verticallyCenter" v-for="(item, index) in fileList" :key="index">
          <i class="mover icondrag icon-drag" :class="dragging ? 'dragging' : ''"></i>
          <span class="img"><img :src="item.imgUrl" alt="" /></span>
          <span v-if="item.type == 'img'" class="text overflowHid1">图片</span>
          <span v-else class="text overflowHid1">视频</span>
          <div class="btn-box">
            <el-tooltip class="item" effect="dark" content="编辑" placement="top" :open-delay="1000"
              ><span class="icon-edit-1" @click.stop="handleCommand(item.type, 'edit', index)"></span
            ></el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="删除"
              placement="top"
              :open-delay="1000"
              ><span class="icon-delete1" @click.stop="handleDel(index)"></span
            ></el-tooltip>
          </div>
        </li>
      </draggable>
    </div>
    <div class="bg-set-dialog-wrap padding12" @click.stop="closebgSetStatu" v-show="showBgSetDialog">
      <div class="bg-set-dialog" @click.stop v-if="showBgSetArr.showImgSet && bgItem">
        <img-upload :imgSrc.sync="bgItem.imgUrl" />
        <img-crop-bg
          class="mt16"
          :clipSize.sync="bgItem.clipSize"
          :repeatType.sync="bgItem.repeatType"
          :alignType.sync="bgItem.alignType"
        />
      </div>
      <div class="bg-set-dialog" @click.stop v-if="showBgSetArr.showVideoSet && bgItem">
        <div class="source-type">
          <el-radio v-model="bgItem.videoCache" :label="true">本地上传</el-radio>
          <el-radio v-model="bgItem.videoCache" :label="false">视频地址</el-radio>
        </div>
        <div v-show="bgItem.videoCache" class="video-source-box">
          <div class="video-bgcard">
            <div class="uploadfailed" v-if="percentage == 'error'">
              <i class="icon-attention"></i>
              <p class="text">上传失败</p>
            </div>
            <div class="uploading" v-else-if="percentage > 0">
              <el-progress
                type="circle"
                :percentage="percentage"
                :width="36"
                :show-text="false"
                :color="themeColor"
              ></el-progress>
              <p class="text">{{ percentage }}%</p>
            </div>
            <img :src="bgItem.imgUrl || defaultVideoBg" alt="" v-else />
          </div>
          <div class="video-upload-box">
            <p class="tips">格式：FIV、MP4<br />大小：2G以下</p>
            <el-upload
              name="file"
              action="https://pan-yz.chaoxing.com/upload"
              accept=".mp4,.m3u8"
              :data="actionData"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-success="handleSuccessHandle"
              :on-error="handleFailHandle"
              :on-progress="handleProgressHandle"
              :show-file-list="false"
            >
              <button class="video-upload-btn">点击上传</button>
            </el-upload>
          </div>
          <el-checkbox class="mt12" v-model="bgItem.loopPlay">循环播放</el-checkbox>
          <el-checkbox class="mt12" v-model="bgItem.autoplay">自动播放</el-checkbox>
        </div>
        <div v-show="!bgItem.videoCache" class="dataUrl-item mb16 video-upload-ipt">
          <el-input type="text" class="mb8" v-model="bgItem.imgUrl" placeholder="请输入https://开头的地址"></el-input>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import complexSetMixin from "./complexSetMixin.js"
import draggable from "vuedraggable"
import default_video_fm from "assets/images/image_placeholder.png"
import { produce } from 'immer'
export default {
  name: 'uploadSet',
  mixins: [complexSetMixin()],
  components: {
    draggable
  },
  props: {
    extraConfig: {
      type: Object,
      default() {
        return {
          sort: false,
          maxLength: 5,
          fileTypes: ['img', 'video']
        }
      }
    }
  },
  computed: {
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    fileList: {
      get() {
        return JSON.parse(JSON.stringify(this.configData || []))
      },
      set(val) {
        this.$emit("update:config", val)
      }
    },
    fileTypeList() {
      return this.bgDropdownList.filter(item => this.extraConfig.fileTypes.includes(item.type))
    }
  },
  data() {
    return {
      dragging: false,
      bgDropdownList: [
        { type: "img", label: "图片", src: require("@/assets/images/icon-img.png") },
        { type: "video", label: "视频", src: require("@/assets/images/icon-video.png") }
      ],
      showBgSetDialog: false,
      percentage: 0,
      bgItem: [],
      bgItemIndex: undefined,
      actionData: {},
      defaultImg: {
        type: "img",
        label: "图片",
        imgUrl: "",
        clipSize: "cover",
        repeatType: "no-repeat",
        alignType: "center center",
        opacity: 100
      },
      defaultVideo: {
        type: "video",
        label: "视频",
        imgUrl: "",
        videoCache: true,
        loopPlay: true,
        autoplay: true
      },
      defaultVideoBg: default_video_fm,
      showBgSetArr: {
        showImgSet: false,
        showVideoSet: false
      },
    }
  },
  methods: {
    startDrag() {
      this.dragging = true
    },
    endDrag() {
      this.dragging = false
    },
    handleCommand(command, type, index) {
      let name = command[0].toUpperCase() + command.substr(1, command.length - 1)
      this.showBgSetDialog = true
      let defaultData = "default" + name
      if (type !== "edit" && this[defaultData]) {
        const newFileList = [...JSON.parse(JSON.stringify(this.configData)), {...this[defaultData]}]
        console.log('新的文件列表是:', newFileList)
        this.fileList = newFileList
      }
      this.$nextTick(() => {
        for (let key in this.showBgSetArr) {
          this.showBgSetArr[key] = "show" + name + "Set" == key ? true : false
        }
        if (name == "Video") {
          this.getUrl()
        }
        let idx = index != undefined ? index : this.fileList.length - 1
        this.bgItemIndex = index
        this.getLocalBg(idx)
      })
    },
    getLocalBg(index) {
      const self = this
      const data = JSON.parse(JSON.stringify(self.fileList[index]))
      this.bgItem = new Proxy(data, {
        get(target, key) {
          return data[key]
        },
        set(target, key, value) {
          self.fileList = produce(JSON.parse(JSON.stringify(self.fileList)), draft => {
            draft[index] = {...draft[index], [key]: value}
          })
          data[key] = value
          return true
        }
      })
    },
    handlePictureCardPreview(file) {},
    handleProgressHandle(response, file) {
      this.percentage = parseInt(file.percentage)
    },
    handleSuccessHandle(response, file, fileList) {
      if (response.result) {
        this.percentage = 0
        this.bgItem.imgUrl = response.data.thumbnail
        this.bgItem.objectId = response.objectId
        this.swiperBackground[this.bgItemIndex] = this.bgItem
        this.showBgSetDialog = false
      } else {
        this.percentage = "error"
      }
    },
    handleFailHandle(err, file, fileList) {},
    // 获取uid
    getUid() {
      let userInfo = this.$store.state.states.userInfo
      if (userInfo) {
        return userInfo.uid
      }
      return new Promise((resolve, reject) => {
        this.$API.getUserInfo().then(res => {
          if (res.data.code === 1) {
            resolve(res.data.data.uid)
          } else {
            reject("err")
          }
        })
      })
    },
    // 获取token
    getToken() {
      return new Promise((resolve, reject) => {
        this.instance.get("usts/yunpan/uservalid").then(res => {
          if (res.status == 200) {
            console.log("res token:>>", res)
            resolve(res.data)
          } else {
            reject("err")
          }
        })
      })
    },
    async getUrl() {
      let token = await this.getToken()
      // let token = "68a97b6e89af8ed91398035f530c4155"
      let uid = await this.getUid()
      this.actionData = {
        uploadtype: "normal",
        puid: uid,
        _from: "cdmh",
        _token: token
      }
    },
    closebgSetStatu() {
      this.showBgSetDialog = undefined
    },
    handleDel(index) {
      this.fileList = this.fileList.filter((item, idx) => {
        return idx !== index
      })
    }
  }
}
</script>
<style scoped lang="scss">
.head {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  margin-bottom: 6px;
}
.swiperComponent {
  font-size: 14px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
}
.optionName {
  margin-right: 10px;
  width: auto;
}
.optionItem_switch_box {
  width: 100%;
  display: flex;
  margin-bottom: 10px;
  flex-wrap: wrap;
  flex-direction: row;
  align-content: center;
}
.harf_item {
  width: 50% !important;
}
.optionItem {
  margin-bottom: 10px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
}
.checkBox {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.checkBox > div {
  width: 30%;
}
.swiper-content {
  margin-bottom: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: left;
}
::v-deep .el-input-number span {
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  height: 93% !important;
}
.swiper-page {
  .bg-item {
    position: relative;
    height: 32px;
    background: var(--inputBackGround);
    border-radius: 4px;
    margin-top: 8px;
    padding: 0 4px;
    &:hover {
      background: var(--inputNuberHoverThemeBgColor);
    }
    &:first-child {
      margin-top: 0;
    }
    .icondrag {
      color: var(--fourthTextColor);
      margin-right: 4px;
      &:hover {
        color: var(--themeColor);
        cursor: grab;
      }
      &.dragging {
        cursor: grabbing;
      }
    }
    .img {
      width: 20px;
      height: 20px;
      border: 1px solid #dee0e3;
      border-radius: 4px;
      overflow: hidden;
      margin-right: 4px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        vertical-align: top;
      }
    }
    .text {
      width: calc(100% - 92px);
    }
    .btn-box {
      span {
        display: inline-block;
        vertical-align: top;
        width: 24px;
        height: 24px;
        border-radius: 4px;
        text-align: center;
        line-height: 24px;
        color: var(--subTextColor);
        cursor: pointer;
        &:hover {
          background: rgba(31, 35, 41, 0.08);
        }
      }
    }
  }
}
.el-dropdown-link {
  display: inline-block;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  color: var(--themeColor);
  text-align: center;
  line-height: 24px;
  &:hover {
    background: rgba(31, 35, 41, 0.08);
  }
}
.bg-menu {
  .el-dropdown-menu__item {
    line-height: 38px;
    padding: 0 12px;
    img {
      display: inline-block;
      vertical-align: top;
      margin-top: 11px;
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
  }
}
::v-deep .chosen {
  background: rgba(43, 103, 255, 0.1) !important;
  border: 1px solid #2b67ff;
  box-shadow: 0px 4px 16px 4px rgba(0, 0, 0, 0.03), 0px 4px 8px rgba(0, 0, 0, 0.02),
    0px 2px 4px -4px rgba(0, 0, 0, 0.02);
}
::v-deep .chosen::after {
  content: "";
  height: 0px;
}
::v-deep .ghost {
  border: none !important;
  box-shadow: none !important;
  background: var(--inputNuberHoverThemeBgColor) !important;
}
::v-deep .ghost::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -4px;
  width: 100%;
  height: 2px;
  background: var(--themeColor);
}
.bg-set-dialog-wrap {
  position: fixed;
  top: 0;
  right: 0;
  width: 260px;
  bottom: 0;
  background: var(--dialogShade);
  z-index: 9999;
}
.bg-set-dialog {
  position: absolute;
  top: 50%;
  right: 0;
  width: 260px;
  padding: 12px;
  transform: translateY(-50%);
  background: var(--leftMenuBgColor);
  border: 1px solid var(--borderColorFour);
  box-sizing: border-box;
  box-shadow: 0 6px 16px -8px rgba(0, 0, 0, 0.08), 0 9px 28px rgba(0, 0, 0, 0.05), 0 12px 48px 16px rgba(0, 0, 0, 0.03);
  border-radius: 4px;
}
.bg-set-dialog .source-type label {
  margin-right: 20px;
}
.video-bgcard {
  display: inline-block;
  vertical-align: top;
  width: 90px;
  height: 90px;
  border: 1px solid var(--sliderBackGround);
  box-sizing: border-box;
  border-radius: 4px;
  overflow: hidden;
}
.video-bgcard > img {
  width: 100%;
  height: 100%;
}
.video-upload-box {
  display: inline-block;
  vertical-align: top;
  margin-left: 16px;
  width: calc(100% - 112px);
}
.video-upload-box .tips {
  margin-bottom: 26px;
  font-size: 12px;
  line-height: 17px;
  color: var(--subTextColor);
}

.video-upload-box ::v-deep .el-upload--picture-card {
  width: 80px;
  height: 28px;
  line-height: 28px;
  border: none;
  background: none;
}
.video-upload-btn {
  width: 80px;
  height: 28px;
  border: 1px solid var(--themeColor);
  box-sizing: border-box;
  border-radius: 4px;
  color: var(--themeColor);
  font-size: 14px;
  line-height: 20px;
  background: transparent;
}
.video-source-box {
  margin-top: 8px;
}

.video-upload-ipt {
  margin-top: 8px;
}
.uploading {
  width: 100%;
  height: 90px;
  background: var(--dataAddActiveBgColor);
  text-align: center;
  padding: 16px 0;
}
.uploading .text {
  font-weight: 600;
  font-size: 14px;
  color: var(--themeColor);
  margin-top: 8px;
  line-height: 20px;
}
.uploadfailed {
  width: 100%;
  height: 100%;
  background: rgba(255, 78, 78, 0.08);
  border: 1px solid #e9e9e9;
  text-align: center;
  color: #ff4e4e;
  padding: 15px;
  font-size: 16px;
}
.uploadfailed .text {
  font-size: 14px;
  line-height: 20px;
}
.mr32 {
  margin-right: 32px;
}
.font-arrangement-btn .btn-active {
  width: calc((100% - 6px) / 2);
}
.swiper-card {
  background: var(--cardBgColor);
  padding: 12px;
  border: 1px solid #e9e9e9;
  border-radius: 4px;
}
.font-arrangement-btn.height32 span {
  font-size: 18px;
  height: 26px;
  line-height: 26px;
}
.font-arrangement-btn.height32 span i {
  line-height: 26px;
}
.height32 {
  height: 32px;
}
::v-deep .effect-select .select_title {
  margin-right: 32px;
}
.pagination-set ::v-deep .el-collapse .el-collapse-item {
  background-color: transparent !important;
}
.toolbar .el-tabs .pagination-set ::v-deep .el-collapse .el-collapse-item__header {
  height: 24px;
  padding-left: 18px !important;
  background: transparent !important;
  font-weight: 400;
  margin-top: 12px;
}
.pagination-set.margint0 ::v-deep .el-collapse .el-collapse-item:first-child .el-collapse-item__header {
  margin-top: 0;
}
.pagination-set ::v-deep .el-collapse-item__wrap .el-collapse-item__content {
  padding-left: 18px !important;
}
.pagination-set ::v-deep .el-collapse .el-collapse-item__header .el-collapse-item__arrow {
  left: 0 !important;
}
.width72 ::v-deep .flex_box .el-input {
  width: 72px !important;
}
.width64 ::v-deep .flex_box .el-input {
  width: 64px !important;
}
.width80 ::v-deep .flex_box .el-input {
  width: 80px !important;
}
.btn-wrapper {
  background-color: var(--inputBg);
  border-radius: 4px;
  padding: 6px 0;
  font-size: 0;
  margin-left: 12px;
  .num-btn {
    display: inline-block;
    width: 36px;
    text-align: center;
    line-height: 20px;
    font-size: 13px;
    cursor: pointer;
    &:not(:last-child) {
      border-right: 1px solid var(--sliderBackGround);
    }
    &:not(.disabled):hover {
      color: var(--themeColor);
    }
    &.disabled {
      color: var(--borderColorSeven);
    }
  }
}
::v-deep .label56 .slider_and_input .fs14.mr16 {
  width: 56px;
}
.tips-btn {
  display: inline-block;
  vertical-align: top;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-size: 14px;
  color: var(--thirdTextColor);
  margin-left: 2px;
  cursor: pointer;
  border-radius: 4px;
}
.tips-btn:hover {
  color: var(--themeColor);
}
.lableWidth4 {
  width: calc(100% - 76px);
}
.childPageSettingBtn {
  background: var(--leftMenuBgColor);
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  font-size: 13px;
  line-height: 18px;
  text-align: center;
  color: var(--themeColor);
  padding: 5px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  &:not(.disabledBtn):hover {
    background: var(--defaultButtonHover);
    cursor: pointer;
  }
  &.is_disabled {
    background: var(--defaultButtonHover);
  }
  .icon-loading1 {
    display: inline-block;
    margin-right: 4px;
    transform: rotate(90deg);
    font-size: 14px;
    color: var(--topOperationAColor);
    vertical-align: middle;
    margin-top: -2px;
    animation: rotation 1s linear infinite;
    &:before {
      color: var(--topOperationAColor);
    }
  }
  &.disabledBtn {
    cursor: not-allowed;
    border: 1px solid var(--themeColorDisabled);
    color: var(--themeColorDisabled);
  }
}
.layoutConfig-card {
  border: 1px solid #e9e9e9;
  border-radius: 4px;
  position: relative;
  .img-box {
    width: 100%;
    height: 122px;
    box-sizing: border-box;
    background-color: rgba(245, 246, 248, 1);
    background-position: center center;
    background-size: contain;
    background-clip: padding-box;
    background-repeat: no-repeat;
    background-size: 100%;
    &[src=""] {
      opacity: 0;
    }
  }
  .footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    padding: 12px;
    gap: 9.13px;
    position: absolute;
    width: 100%;
    height: 42px;
    left: 0px;
    bottom: 0px;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(14.6087px);
    .title {
      font-size: 13px;
      line-height: 18px;
      color: #000000;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      width: 104px;
    }
    .desc {
      cursor: pointer;
      font-weight: 400;
      font-size: 13px;
      line-height: 18px;
      color: #2b67ff;
      display: flex;
      align-items: center;
    }
  }
  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 4px 4px 4px 12px;
    background: #fbfcfd;
    .title {
      font-weight: 500;
      font-size: 13px;
      line-height: 18px;
      color: rgba(0, 0, 0, 0.8);
    }
    .btn {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #2b67ff;
      cursor: pointer;
    }
  }
  .config-content {
    padding: 12px 12px 0 12px;
    font-weight: 400;
    font-size: 13px;
    line-height: 18px;
    color: rgba(0, 0, 0, 0.8);
    .el-radio {
      margin-top: 0;
      margin-bottom: 0;
      margin-right: 0;
      white-space: pre-wrap;
    }
    .cx-check-box {
      display: inline-block;
    }
    .tips-btn {
      line-height: 20px;
    }
  }
}
.cover {
  height: 132px;
}
.tips-btn {
  display: inline-block;
  vertical-align: top;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  font-size: 14px;
  color: var(--thirdTextColor);
  margin-left: 2px;
  cursor: pointer;
  border-radius: 4px;
}
.tips-btn:hover {
  color: var(--themeColor);
}
.toolbar .padding0 ::v-deep .el-collapse-item__content {
  padding: 0 16px 0 16px !important;
}
</style>